export const MAX_CONTATOS_COMPARTILHE = 25

export const ORIENTACAO_CONTATOS =
  'Escolha as pessoas com quem você realmente quer se conectar agora. A qualidade da escolha importa mais que a quantidade.'

export type AbordagemContato = 'individual' | 'aula'
export type FocoContato = 'bemestar' | 'negocio' | ''
export type FormatoJornada = 'individual' | 'aula'

export interface ContatoCompartilhe {
  id: string
  nome: string
  abordagem: AbordagemContato
  foco: FocoContato
}

export interface ItemChecklist {
  id: string
  dia: number
  texto: string
  concluido: boolean
  tipo?: 'reflexao' | 'curso' | 'padrao'
  linkCurso?: string
}

export interface CronogramaCompartilhe {
  formato: FormatoJornada
  inicioIso: string
  itens: ItemChecklist[]
}

export const MENSAGENS_BEMESTAR = [
  'Oi [nome]! Estava pensando em você e lembrei de uma coisa. Tenho oferecido para algumas pessoas uma conversa rápida e gratuita, só para entender o que está pesando mais na saúde ou nas emoções agora. Sem pressão, sem venda. Teria interesse?',
  'Oi [nome]! Tenho oferecido uma escuta e consulta de bem-estar de forma gratuita para algumas pessoas. O objetivo é entender mais sobre você e te dar uma orientação sobre sua saúde e emoções nesse momento. Faz sentido agendarmos?',
  'Oi [nome]! Vi que você já teve contato com meu trabalho de bem-estar e óleos essenciais. Separei um tempo para te dar uma orientação personalizada. Posso te chamar essa semana?',
  'Oi [nome]! Vi que você já fez seu diagnóstico de bem-estar comigo e queria retomar contato. Separei um tempo para te dar uma orientação sobre o que apareceu no seu resultado. Posso te chamar essa semana?',
] as const

export const MENSAGENS_NEGOCIO = [
  'Oi [nome], tudo bem? Estou super corrida hoje, mas precisava muito da sua opinião sobre uma coisa. Você sempre foi uma pessoa que sabe se virar bem com as coisas. Estou desenvolvendo um projeto novo e queria muito ouvir o que você acha. Você teria 15 minutos essa semana?',
  'Oi [nome]! Rapidinho: você é uma das pessoas mais determinadas que eu conheço, e por isso pensei em você pra uma oportunidade que estou construindo. Não sei se faz sentido pra esse momento seu, mas quero te mostrar. Você tem uns minutos amanhã ou depois?',
  'Oi [nome]! Você está aberta a conhecer uma forma de gerar uma renda extra, sem comprometer o que você já faz hoje? Se fizer sentido, te mostro rapidinho como funciona.',
  'Oi [nome]! Preciso ser rápida porque hoje está corrido, mas não queria deixar de te chamar: estou selecionando algumas pessoas pra conhecer um projeto que estou construindo. Você toparia dar uma olhada? Prefere conversar hoje à noite ou amanhã de manhã?',
] as const

export function primeiroNome(nome: string): string {
  const parte = String(nome || '').trim().split(/\s+/)[0]
  return parte || 'você'
}

export function linkDiagnosticoConsultora(slug: string): string {
  const usuario = String(slug || 'monica').trim() || 'monica'
  return `https://www.descubraseusoleos.com.br/?c=${encodeURIComponent(usuario)}`
}

export function linkCursoUmaGota(slug: string): string {
  const usuario = String(slug || 'monica').trim() || 'monica'
  return `https://www.descubraseusoleos.com.br/curso?indicado_por=${encodeURIComponent(usuario)}`
}

export function montarMensagemPronta(
  modelo: string,
  nome: string,
  linkDiagnostico: string,
): string {
  const texto = modelo.replace(/\[nome\]/g, primeiroNome(nome))
  const link = String(linkDiagnostico || '').trim()
  if (!link) return texto
  return `${texto}\n\nFaça seu diagnóstico gratuito: ${link}`
}

export function gerarTokenCompartilhe(): string {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
  let token = 'jc'
  for (let i = 0; i < 14; i++) {
    token += chars[Math.floor(Math.random() * chars.length)]
  }
  return token
}

export function novoIdContato(): string {
  return `c${Date.now().toString(36)}${Math.random().toString(36).slice(2, 7)}`
}

export function parseJsonSafe<T>(valor: unknown, fallback: T): T {
  if (typeof valor !== 'string' || !valor.trim()) return fallback
  try {
    return JSON.parse(valor) as T
  } catch {
    return fallback
  }
}

export function contatoVazio(): ContatoCompartilhe {
  return {
    id: novoIdContato(),
    nome: '',
    abordagem: 'individual',
    foco: '',
  }
}

function item(
  dia: number,
  texto: string,
  tipo: ItemChecklist['tipo'] = 'padrao',
  extra: Partial<ItemChecklist> = {},
): ItemChecklist {
  return {
    id: `d${dia}-${Math.random().toString(36).slice(2, 9)}`,
    dia,
    texto,
    concluido: false,
    tipo,
    ...extra,
  }
}

export function montarChecklist14Dias(params: {
  formato: FormatoJornada
  contatos: ContatoCompartilhe[]
  linkCursoUmaGota: string
}): CronogramaCompartilhe {
  const formato = params.formato === 'aula' ? 'aula' : 'individual'
  const nomes = params.contatos
    .map((c) => String(c?.nome || '').trim())
    .filter(Boolean)
  const linkCurso = String(params.linkCursoUmaGota || '').trim()
  const itens: ItemChecklist[] = []

  itens.push(
    item(
      1,
      'Reflita: como sua vida mudou desde que você começou a usar os óleos essenciais?',
      'reflexao',
    ),
  )

  if (formato === 'aula') {
    itens.push(item(1, 'Defina a data e horário da sua aula (presencial ou online).'))
    itens.push(item(2, 'Convide seu grupo de contatos para a aula.'))
    nomes.forEach((nome) => {
      itens.push(item(2, `Convide ${nome} para a aula.`))
    })
    itens.push(item(3, 'Prepare o ambiente e os materiais.'))
    itens.push(item(5, 'Envie lembrete 48h antes.'))
    itens.push(item(7, 'Envie lembrete 2-4h antes.'))
    itens.push(
      item(
        8,
        'Envie o link do curso Uma Gota de Equilíbrio para quem participou se aprofundar por conta própria.',
        'curso',
        { linkCurso },
      ),
    )
    itens.push(item(10, 'Faça o acompanhamento com quem participou e anote os próximos passos.'))
    itens.push(item(14, 'Encerre o ciclo: revise quem avançou e quem ainda precisa de um toque.'))
  } else {
    itens.push(item(1, 'Compartilhe sua experiência pessoal com quem estiver mais aberto hoje.'))
    nomes.forEach((nome, idx) => {
      const diaEnvio = Math.min(7, 2 + (idx % 6))
      itens.push(item(diaEnvio, `Envie a mensagem escolhida para ${nome}.`))
    })
    nomes.forEach((nome, idx) => {
      const diaAcomp = Math.min(12, 8 + (idx % 4))
      itens.push(item(diaAcomp, `Faça o acompanhamento com ${nome}.`))
    })
    nomes.forEach((nome, idx) => {
      const diaFecha = Math.min(14, 11 + (idx % 4))
      itens.push(item(diaFecha, `Apresentação e fechamento com ${nome}.`))
    })
    if (nomes.length === 0) {
      itens.push(item(2, 'Envie as primeiras mensagens para as pessoas da sua lista.'))
      itens.push(item(8, 'Faça o acompanhamento com cada pessoa da lista.'))
      itens.push(item(12, 'Faça a apresentação e o fechamento com quem avançou.'))
    }
    itens.push(item(14, 'Encerre o ciclo: revise quem avançou e quem ainda precisa de um toque.'))
  }

  itens.sort((a, b) => a.dia - b.dia || a.texto.localeCompare(b.texto, 'pt-BR'))

  return {
    formato,
    inicioIso: new Date().toISOString(),
    itens,
  }
}

export function progressoChecklist(cronograma: CronogramaCompartilhe | null): {
  feitos: number
  total: number
} {
  const itens = cronograma?.itens || []
  return {
    feitos: itens.filter((i) => i.concluido).length,
    total: itens.length,
  }
}

export function rotuloStatusAcesso(status: string, etapaAtual: string): string {
  if (status === 'concluido' || etapaAtual === 'concluido') return 'Concluída'
  return 'Em andamento'
}

export function linkPublicoCompartilhe(token: string): string {
  const t = String(token || '').trim()
  return `https://www.descubraseusoleos.com.br/jornada-compartilhe/${encodeURIComponent(t)}`
}

export function normalizarContatos(raw: unknown): ContatoCompartilhe[] {
  if (!Array.isArray(raw)) return []
  return raw.map((item) => {
    const obj = item && typeof item === 'object' ? (item as Record<string, unknown>) : {}
    const abordagem = obj.abordagem === 'aula' ? 'aula' : 'individual'
    const focoRaw = obj.foco
    const focoNegocio = obj.focoNegocio === true
    const foco: FocoContato =
      focoRaw === 'negocio' || focoNegocio ? 'negocio' : focoRaw === 'bemestar' ? 'bemestar' : ''
    return {
      id: String(obj.id || novoIdContato()),
      nome: String(obj.nome || '').trim(),
      abordagem,
      foco,
    }
  })
}
